export const SHOW_LOADING_OVERLAY = 'SHOW_LOADING_OVERLAY';

export const HIDE_LOADING_OVERLAY = 'HIDE_LOADING_OVERLAY';